<template>
  <div class="ui-collapse" :class="{ 'ui-collapse--open': isOpen }">
    <button type="button" class="ui-collapse__toggle" @click="toggle">
      <div class="ui-collapse__info">
        <div class="ui-collapse__titles">
          <p class="ui-collapse__title mb-1">{{ headerText }}</p>
          <span class="ui-collapse__subtitle">{{ subTitle }}</span>
        </div>
        <div class="ui-collapse__meta">
          <slot name="meta">
            <div
                v-for="(m, i) in metaData"
                :key="i"
                class="ui-collapse__meta-icon"
            >
              <span class="ui-collapse__count">{{ m.value }} {{ m.label }}</span>
              <div v-if="i < metaData.length - 1" class="ui-collapse__divider"></div>
            </div>
          </slot>
          <i
              class="fas fa-chevron-down ui-collapse__chevron"
              :class="{ 'ui-collapse__chevron--open': isOpen }"
          />
        </div>
      </div>
    </button>

    <transition name="fade">
      <div v-if="isOpen" class="ui-collapse__body">
        <slot name="items"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'UICollapsed',
  props: {
    headerText: { type: String, default: 'Título' },
    subTitle:   { type: String, default: '' },
    metaData:   { type: Array,  default: () => [] }
  },
  data() {
    return { isOpen: false };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@src/design/ui-design/_variables.scss';

.ui-collapse {
  @include collapse-base();

  &--open {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &__toggle {
    background: transparent;
    border: none;
    width: 100%;
    text-align: left;
    padding: 0;
  }

  &__info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 2rem;
  }

  &__titles {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__title {
    @include font-16px-title;
  }

  &__subtitle {
    @include font-14px-subtitle;
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 47px;

    &-icon {
      display: flex;
      gap: 47px;
      align-items: center;
    }
  }

  &__count {
    @include font-15px;
  }

  &__divider {
    width: 1px;
    align-self: stretch;
    background-color: $gray-100-1;
  }

  &__chevron {
    color: $gray-200;
    transition: transform 0.3s ease;

    &--open {
      transform: rotate(180deg);
    }
  }

  &__body {
    margin-top: 12px;
    width: 100%;
    cursor: default;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .fade-enter-active,
  .fade-leave-active {
    transition: none;
  }

  .ui-collapse__chevron {
    transition: none;
  }
}
</style>
